// Generated types for PortExpansionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { IntrinsicExpansionTaskReadAPI, IntrinsicExpansionTaskWriteAPI } from './intrinsicexpansiontask';
import { IntrinsicExpansionTaskReadAPISchemaObject, IntrinsicExpansionTaskWriteAPISchemaObject } from './intrinsicexpansiontask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PortExpansionTaskReadAPI extends IntrinsicExpansionTaskReadAPI {
}

export interface PortExpansionTaskWriteAPI extends IntrinsicExpansionTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PortExpansionTaskReadAPISchema: z.ZodType<PortExpansionTaskReadAPI> = IntrinsicExpansionTaskReadAPISchemaObject.extend({}).passthrough();

export const PortExpansionTaskWriteAPISchema: z.ZodType<PortExpansionTaskWriteAPI> = IntrinsicExpansionTaskWriteAPISchemaObject.extend({}).passthrough();
